import gql from 'graphql-tag'

export const fetchCreateBasketMutation = gql`
mutation {
  createEmptyCart
}
`
